import type { Action } from "svelte/action";
import type { ActionReturn } from "svelte/action";

/**
 * Dispatch event on click outside of node
 * @function clickOutside add use:clickOutside and on:click_outside={handleFunction}
 * to any container and all clicks outside of container will trigger handleFunction
 * @param node is the node that clicking outside of will trigger event
 * @return removes click event listener
 */
const clickOutside: Action = (node) => {
  const handleClick = (event) => {
    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      node.dispatchEvent(new CustomEvent("click_outside", node));
    }
  };

  document.addEventListener("click", handleClick, true);

  return {
    destroy() {
      document.removeEventListener("click", handleClick, true);
    },
  };
};
interface Attributes {
  "on:thresholdOver": undefined | ((e: CustomEvent) => void); //undefined for fwd'd events, might need to look into bubbling the actual type
}
type Params = { threshold: number; horizontal: boolean };

function scrollThreshold(node: HTMLElement, { threshold, horizontal }: Params): ActionReturn<Params, Attributes> {
  const onScroll = (e: Event) => {
    const element = e.target as HTMLElement;

    const offset = horizontal
      ? element.scrollWidth - element.clientWidth - element.scrollLeft
      : element.scrollHeight - element.clientHeight - element.scrollTop;
    if (offset <= threshold) {
      node.dispatchEvent(new CustomEvent("thresholdOver", node));
    }
  };
  node.addEventListener("scroll", onScroll);
  node.addEventListener("resize", onScroll);

  return {
    destroy() {
      node.removeEventListener("scroll", null);
      node.removeEventListener("resize", null);
    },
  };
}

const removeDuplicatesById = (items, key) => {
  return new Promise((resolve, reject) => {
    const itemsNoDups = items.reduce((acc, current) => {
      const x = acc.find((item) => +item[key] === +current[key]);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    resolve(itemsNoDups);
  });
};

const downloadFile = async (url, downloadFileName) => {
  const response = await fetch(url);
  console.log(response);
  if (!response.ok || response.status !== 200) {
    console.log("error");
    throw new Error("Something went wrong. Please try again later");
  } else {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadFileName;
    link.click();
  }
};

export { clickOutside, scrollThreshold, removeDuplicatesById, downloadFile };
